import "./stock_details.css";
import React, { useState, useForm, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Form from 'react-bootstrap/Form'
import swal from 'sweetalert';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import DoneIcon from "@mui/icons-material/Done";
import Fab from '@mui/material/Fab';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from '@mui/icons-material/Search';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';

import { get_request_delivery_infos_for_file, update_purchase_request_using_stock } from "../../../../../services/purchase_service";
import { verify_products_existance_in_stock } from "../../../../../services/stock_service";
import { get_categories_forAll_services, download_file_by_path, get_suppliers } from "../../../../../services/for_allServices";
import Delivery_form_header_pdf from "./delivery_form_pdf/delivery_form_header_pdf";
import { pdf } from "@react-pdf/renderer";

import SearchStock from "./search_in_verify_stock/search_stock";
import ProductReplacement from "./ProductReplacement";
import Intern_delivery_supposed_date_modal from "./Delivery_supposed_date_modal_intern/Intern_delivery_sup_da_modal";
import View_refuse_reason from "../../view_refuse_reason/view_refuse_reason";
const columns = [
    { id: 'product_name', label: "Produit", minWidth: 0, align: 'left' },
    { id: 'replaced_product_name', label: "Produit remplaçant", minWidth: 0, align: 'left' },

    { id: 'product_reference', label: "Réference du produit", minWidth: 0, align: 'left' },
    { id: 'product_code', label: "Code de produit", minWidth: 0, align: 'left' },
    { id: 'supplier', label: "Fournisseur", minWidth: 0, align: 'left' },
    { id: 'quantity_requested', label: "Quantité (Demandé)", minWidth: 0, align: 'left' },
    { id: 'product_quantity', label: "Quantité (Stock)", minWidth: 0, align: 'left' },
    { id: 'product_quantity_selected', label: "Quantité", minWidth: 0, align: 'left' },
];

function get_supplier_by_id(id, suppliers) {
    let tmp_supplier = "";
    for (let supplier of suppliers) {
        if (supplier.id === id) { tmp_supplier = supplier.fullName; break; }
    }
    return tmp_supplier;
}

function Products({ categories, suppliers, products, set_selected_quantity, setexisting_products, update_list_products_taken_from_stock, bl_file_path }) {



    function getCategorieById(id) {
        var categorie = "";
        categories.map((catg) => {
            if (catg.id_category === id) categorie = catg.name;
        })
        return categorie;
    }

    function set_selected_quantity(value, id) {
        let tmp_products = [...products];
        console.log(tmp_products[id]);
        let selected_quantity = value ? parseInt(value) : "";
        tmp_products[id].product_quantity_selected = selected_quantity;
        let tmp_requested_quantity = parseInt(tmp_products[id].quantity_requested);
        let tmp_product_stock_quantity = parseInt(tmp_products[id].product_quantity);
        if (selected_quantity > tmp_product_stock_quantity) {
            swal("Vous avez dépassé la quantité du stock !", {
                icon: "error",
                buttons: true,
            });
            selected_quantity = 0;
        }
        if (selected_quantity > tmp_requested_quantity) {
            swal("Vous avez dépassé la quantité demandée !", {
                icon: "error",
                buttons: true,
            });
            selected_quantity = 0;
        }

        tmp_products[id].product_quantity_selected = selected_quantity;
        update_list_products_taken_from_stock(tmp_products[id], selected_quantity == 0)
        setexisting_products(tmp_products);
    }


    return (
        <>
            {
                products.map((product, id) => (
                    <TableRow key={"product_col" + id}>
                        <TableCell align="left">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span className='product_cell_title_container'>
                                    <span id="title">{product.product_name}</span>
                                    <div className='product_cell_categorie_container'>
                                        <span>Famille d'achat : </span>{getCategorieById(parseInt(product.product_category))}
                                    </div>
                                </span>
                            </div>
                        </TableCell>
                        <TableCell>
                            <div key={product.product_code}>
                                {product.replaced_product_name ? ` ${product.replaced_product_name}` : 'aucun'}
                            </div>
                        </TableCell>
                        <TableCell align="left">
                            {product.product_reference}
                        </TableCell>
                        <TableCell align="center">
                            {product.product_code}
                        </TableCell>
                        <TableCell align="center">
                            {get_supplier_by_id(product.supplier, suppliers)}
                        </TableCell>
                        <TableCell align="center">
                            {parseInt(product.quantity_requested) - product.product_quantity_selected}
                        </TableCell>
                        <TableCell align="center">
                        {bl_file_path != null
                        ? product.product_quantity
                        : parseInt(product.product_quantity) - product.product_quantity_selected}
                        </TableCell>
                        <TableCell align="center">
                            <Form.Control
                                className="amount_container"
                                autoComplete="new-password"
                                type="number"
                                value={product.product_quantity_selected}
                                onChange={(e) => set_selected_quantity(e.target.value, id)}
                                disabled={bl_file_path != null}
                            />
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}


const Stock_products_details = ({ categories, suppliers, existing_products, setexisting_products, update_list_products_taken_from_stock, bl_file_path }) => {
    return (
        <TableContainer className="order_plus_details_table_container stock_products_details_table_container">
            <Table>
                <TableHead>
                    <TableRow>
                        {
                            columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>{column.label}</TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        existing_products.length !== 0
                            ?
                            <>
                                <Products categories={categories} suppliers={suppliers} products={existing_products}
                                    setexisting_products={setexisting_products} update_list_products_taken_from_stock={update_list_products_taken_from_stock} bl_file_path={bl_file_path} />
                            </>

                            : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun produit disponible</div>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )

}

//hada second one
const Stock_details_accordian = ({ request_orders, request_code, request_details, setWait_submitting, able_to_process_request }) => {

    let user = JSON.parse(localStorage.getItem('user-info'))
    const user_id = user.id;
    const user_role = user.role;

    const [existing_products, setexisting_products] = useState([]);
    const [requested_products, setRequested_products] = useState(null);
    // const [wait_submitting, setwait_submitting] = useState(false);
    const [products_taken, setproducts_taken] = useState(null);
    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    const [products_taken_from_stock, setproducts_taken_from_stock] = useState([]);
    const [bl_file_path, setbl_file_path] = useState(null);

    const [suppliers, setsuppliers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [openSearchDialog, setOpenSearchDialog] = useState(false);
    const [global_product_amount, setGlobal_product_amount] = useState(null);
    const [selectedMismatchProduct, setSelectedMismatchProduct] = useState(null);

    const [selectedDate, setSelectedDate] = useState(null);
    const [isDeliveryConfirmed, setIsDeliveryConfirmed] = useState(null);
    const [openDateDialog, setOpenDateDialog] = useState(false);
    const [stockStatus, setStockStatus] = useState(null);
    const [refuse_reason, setRefuse_reason] = useState(null);
    const [replaced_product_name, setReplaced_product_name] = useState(null);

    useEffect(() => {

        async function load_data() {
            setWait_submitting(true);

            await get_suppliers().then((response) => {
               // console.log(response.data);
                setsuppliers(response.data);
            }).catch((error) => {
                console.log(error.response);
            })

            await get_categories_forAll_services().then((response) => {
                setCategories(response.data);
            }).catch((error) => {
                //console.log(error.response);
            });

            let requested_products_tmp = [];
            Object.keys(request_orders).map((supplier, id) => {
                request_orders[supplier].products.map((product) => {
                    requested_products_tmp.push(product);
                })
            });
            console.log("requested_products_tmp", request_orders,"lakhor", requested_products_tmp);      
            let tmp_products_taken = [];
            let tmp_stock_processing = {};
            if (request_details.stock_processing) {
                tmp_stock_processing = JSON.parse(request_details.stock_processing);
                setbl_file_path(tmp_stock_processing.bl_file);
                setStockStatus(tmp_stock_processing.status);
                setRefuse_reason(tmp_stock_processing.non_conformity_reason);
                //heree/////////
                setIsDeliveryConfirmed(tmp_stock_processing.delivery_date);
                tmp_products_taken = tmp_stock_processing.products_taken;
            }
            setproducts_taken(tmp_products_taken);
            await setRequested_products(requested_products_tmp);
            await verify_stock(requested_products_tmp, tmp_products_taken);
            setWait_submitting(false);

        }

        if (request_orders && request_details) {
            load_data();
        }

    }, []);

    async function verify_stock(products, products_taken_tmp) {
        // setWait_submitting(true);

        console.log("products==from demande", products);
        let products_codes = [];
        for (let product of products_taken_tmp) {
            products_codes.push(product.product_code);
        }
        for (let product of products) {
            if (products_codes.indexOf(product.product_code)) products_codes.push(product.product_code);
        }
        let formData = new FormData();
        formData.append("products_codes", JSON.stringify(products_codes));
        try {
            let tmp_exisitng_products = await verify_products_existance_in_stock(formData).then((response) => {
                console.log("found in stock", response.data);
                return response.data;
            }).catch((error) => {
                console.group(error.response);
            });
            tmp_exisitng_products.map((pr_ex) => {
                for (let pr_req of products_taken_tmp) {
                    if (pr_req.product_code == pr_ex.product_code) {
                        Object.keys(pr_req).map((key) => (
                            pr_ex[key] = pr_req[key]
                        ))
                        return;
                    }
                }
                for (let pr_req of products) {
                    if (pr_req.product_code == pr_ex.product_code) {
                        pr_ex["requested_product_code"] = pr_req["product_code"];
                        pr_ex["requested_product_supplier"] = pr_req["id_supplier"];
                        pr_ex["quantity_requested"] = pr_req["product_amount"];
                        setGlobal_product_amount(pr_req["product_amount"]);

                        pr_ex["product_quantity_selected"] = 0;
                        break;
                    }
                }
            });
            setexisting_products(tmp_exisitng_products);
        } catch (error) {
            console.error("Error verifying stock:", error.response);
        }
    }

    async function update_list_products_taken_from_stock(product, remove = false) {
        let tmp_products_taken_from_stock = [...products_taken_from_stock];

        const existingIndex = tmp_products_taken_from_stock.findIndex(
            (pr) => pr.product_code === product.product_code
        );

        if (remove) {
            if (existingIndex !== -1) {
                tmp_products_taken_from_stock.splice(existingIndex, 1);
            }
        } else {
            if (existingIndex !== -1) {
                // update the quantity
                tmp_products_taken_from_stock[existingIndex] = product;
            } else {
                tmp_products_taken_from_stock.push(product);
            }
        }

        setproducts_taken_from_stock(tmp_products_taken_from_stock);
    }

    async function set_bl_file_content(taken_products) {
        let products_tmp = [];
        taken_products.map((product) => {
            products_tmp.push({
                "product_reference": product.product_code,
                "product_code": product.product_code,
                "title": product.product_name,
                "product_amount": product.product_quantity_selected
            })
        });
        let order_data = {}
        let formData = new FormData();
        formData.append("request_code", request_code);
        await get_request_delivery_infos_for_file(formData).then((response) => {
            order_data = response.data;
            order_data["products"] = products_tmp;
            console.log("get_request_delivery_infos_for_file", response.data);
        }).catch((error) => {
            console.log(error.response);
        });


        const blob = await pdf((
            <Delivery_form_header_pdf order_data={order_data} />
        )).toBlob();

        return blob;
    }

    ///////////////////////////////////////////////////////////////////////////////////
    async function set_bl() {
        setWait_submitting(true);
        let json_data = {};
        let tmp_products_taken = [];
        for (let taken_product of products_taken_from_stock) {
            json_data = {};
            json_data["requested_product_code"] = taken_product.requested_product_code;
            json_data["product_reference"] = taken_product.product_reference;
            json_data["product_code"] = taken_product.product_code;
            json_data["product_name"] = taken_product.product_name;
            json_data["product_supplier"] = taken_product.supplier;
            json_data["product_category"] = taken_product.product_category;
            json_data["product_price"] = taken_product.product_price;
            json_data["requested_product_supplier"] = taken_product.requested_product_supplier;
            json_data["product_quantity"] = taken_product.product_quantity;
            json_data["product_quantity_selected"] = taken_product.product_quantity_selected;
            json_data["product_reference"] = taken_product.product_reference;
            json_data["quantity_requested"] = taken_product.quantity_requested;
            json_data["selected"] = true;
            json_data["replaced_product_name"] = taken_product.replaced_product_name;

            tmp_products_taken.push(json_data);
        }

        console.log("tmp_products_taken =*********=", products_taken_from_stock);
        let tmp_originally_requested_products = {};
        let tmp_new_requested_products = {};
        let json_data_new_infos = {};
        let tmp_id_supplier;
        for (let original_order of requested_products) {
            json_data = {
                "product_code": original_order.product_code,
                "product_amount": original_order.product_amount
            };
            json_data_new_infos = get_new_request_infos_based_on_taken_products(tmp_products_taken, original_order.product_code);
            tmp_id_supplier = original_order.id_supplier;
            if (!tmp_originally_requested_products.hasOwnProperty(tmp_id_supplier)) {
                tmp_originally_requested_products[tmp_id_supplier] = [json_data]
                tmp_new_requested_products[tmp_id_supplier] = [json_data_new_infos ? json_data_new_infos : json_data];
            } else {
                tmp_originally_requested_products[tmp_id_supplier].push(json_data)
                tmp_new_requested_products[tmp_id_supplier].push(json_data_new_infos ? json_data_new_infos : json_data)
            }
        }
        const blob = await set_bl_file_content(products_taken_from_stock);

        let formData = new FormData();
        formData.append("request_code", request_code);
        formData.append("performed_by", user_id);
        formData.append("requester_departement", request_details.requester_departement);
        formData.append("requested_by", request_details.requested_by);
        formData.append("stock_processing", JSON.stringify({
            "originally_requested_products": tmp_originally_requested_products,
            "products_taken": tmp_products_taken
        }));
        formData.append("new_requested_products", JSON.stringify(tmp_new_requested_products));
        /* var fileURL = window.URL.createObjectURL(blob);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', request_code+"_Bon de livraison"+".pdf");
            document.body.appendChild(fileLink);
            fileLink.click(); */
        if (blob) formData.append("bl_file", blob, "order.pdf");
        await update_purchase_request_using_stock(formData).then((response) => {
            console.log("responsee", response);
            setbl_file_path(response.data.bl_file);
            setStockStatus(response.data.stock_processing.status);
        
            swal("Bon de livraison généré avec succès !", {
                icon: "success",
                buttons: true,
            });
        
        }).catch((error) => {
            console.log(error.response);
            swal("Une erreur est survenue lors de la génération du bon de livraison.", {
                icon: "error",
                buttons: true,
            });
        });
        
        
        setWait_submitting(false);

    }


    function get_new_request_infos_based_on_taken_products(products_taken, product_code) {
        let product_taken_infos = products_taken.filter((pr) => pr.requested_product_code == product_code);
            if (product_taken_infos.length != 0) {
            // Calculate remaining quantity
            const remaining_quantity = product_taken_infos[0].quantity_requested - product_taken_infos[0].product_quantity_selected;

            // Only create a new requested product if there is remaining quantity
            if (remaining_quantity > 0) {
                return {
                    "product_code": product_code,  // keep original requested product code
                    "product_amount": remaining_quantity
                }
            }
        }
        return null;
    }


    async function download_bl_file(e, path) {
        e.stopPropagation();
        let formData = new FormData();
        formData.append("file_path", path);
        download_file_by_path(formData).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            let file_extension = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }
            fileLink.setAttribute('download', request_code + "_Bon de livraison" + "." + file_extension);
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch((error) => {
            console.log(error.response);
        })
    }


    const handleOpenSearch = (e) => {
        e.stopPropagation();

        setOpenSearchDialog(true);
    };


    const handleCloseSearch = () => {
        setOpenSearchDialog(false);
    };



    const handleChooseFromStock = (item) => {
        let transformedItem = {
            archived: item.archived,
            created_at: item.created_at,
            id: item.id,
            product_category: item.product_category,
            product_code: item.products_by_supplier[0]?.product_code || "",
            product_description: item.product_description,
            product_name: item.product_name,
            product_price: item.average_price,
            product_quantity: item.product_quantity,
            product_quantity_selected: 0,
            product_reference: item.product_reference,
            quantity_requested: global_product_amount,
            requested_product_code: item.products_by_supplier[0]?.product_code || "",
            requested_product_supplier: item.products_by_supplier[0]?.supplier || "",
            supplier: item.products_by_supplier[0]?.supplier || "",
            updated_at: item.products_by_supplier[0]?.updated_at || item.updated_at
        };
        const match = requested_products.find(pr => pr.product_code === transformedItem.product_code);

        console.log("chofi", requested_products);

        if (!match) {
            setSelectedMismatchProduct(transformedItem);
        } else {
            transformedItem["requested_product_code"] = transformedItem.product_code;
            setexisting_products((prev) => [...prev, transformedItem]);
        }
        setOpenSearchDialog(false);

    };

    const handleConfirmReplacement = (productCode) => {
        const replacedProduct = requested_products.find(pr => pr.product_code === productCode);

        const updatedItem = {
            ...selectedMismatchProduct,
            requested_product_code: replacedProduct.product_code,
            replaced_product_name: replacedProduct.title,
            quantity_requested: replacedProduct.product_amount
        };

        setexisting_products((prev) => [...prev, updatedItem]);
        setSelectedMismatchProduct(null);
        setReplaced_product_name(replacedProduct.title);
    };


    const handleDelivery = () => {
        setOpenDateDialog(true);
    };


    function state(request_state) {
        return (
            <>
                {
                    request_state === "En cours de livraison"
                        ? <Button variant="contained" className="status_waiting">{request_state}</Button>
                        : request_state === "non conforme"
                            ? <Button variant="contained" className="status_deny">{request_state}</Button>
                            : request_state === "reçu" || request_state === "conforme"
                                ? <Button variant="contained" className="status_success">{request_state}</Button>
                                : <Button variant="contained" className="status_default">Statut inconnu</Button>
                }
            </>
        );
    }





    return (
        <Accordion>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <div className='order_accordion_header'>
                        <div className='accordion_header_content'>
                            <span>Vérification Stock </span>
                            <>
                                {
                                    existing_products.length != 0
                                        ? <div className="existing_products_indicator_container">
                                            <div className="existing_products_indicator">{existing_products.length}</div>
                                        </div>
                                        : <></>
                                }
                            </>
                        </div>

                        <div className='action_button_container' >
                            <div className="request_state_container" >
                                {stockStatus &&
                                    <div className='request_state_container'>
                                        {state(stockStatus)}

                                    </div>}
                                <div>
                                    {
                                        stockStatus === "non conforme"
                                            ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_reason_modal(refuse_reason) }}>Motif</span>
                                            : <></>
                                    }
                                </div>

                            </div>
                            <span style={{ display: 'flex' }}>
                                <Tooltip title="Générer le bon de livraison" placement="bottom" >
                                    <span style={{ marginLeft: '6px' }}>
                                        <Fab size="small" onClick={(e) => download_bl_file(e, bl_file_path)} color='default' style={{ backgroundColor: '#efefef' }}
                                            className={bl_file_path != null ? "round_button" : "round_button disabled_button"} >
                                            <GetAppRoundedIcon className="my_icon" />
                                        </Fab>
                                    </span>
                                </Tooltip>
                            </span>
                            <span className={able_to_process_request?"":"disabled_button"}>
                                <Tooltip title="Chercher dans le stock">
                                    <Fab className={bl_file_path != null ? "add_new_object_fab add_new_object_fab_big disabled_button" : "add_new_object_fab add_new_object_fab_big"} onClick={(e) => handleOpenSearch(e)} >
                                        <SearchIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                </Accordion.Header>
                <Accordion.Body className={able_to_process_request?"":"disabled_button"}>
                    <div className="order_plus_details_container">
                        {
                            suppliers.length != 0
                                ? <Stock_products_details categories={categories} suppliers={suppliers} existing_products={existing_products}
                                    setexisting_products={setexisting_products} update_list_products_taken_from_stock={update_list_products_taken_from_stock} bl_file_path={bl_file_path} />
                                : <></>
                        }
                        <div className={"proceed_button_container"}>
                            {bl_file_path == null ?
                                <Button variant="contained" className="submit_but valide_but"
                                    startIcon={<DoneIcon className="my_icon" />} onClick={set_bl} >
                                    Générer le bon de livraison
                                </Button>
                                : <></>}
                        </div>
                        <div className="proceed_button_container">

                        {bl_file_path != null  && ( (stockStatus != "En cours de livraison" && stockStatus != "conforme" && stockStatus != "reçu")|| stockStatus === "non conforme")?
                                <Button
                                    variant="contained"
                                    className="submit_but valide_but"
                                    startIcon={<LocalShippingTwoToneIcon className="my_icon" />}
                                    onClick={handleDelivery}
                                >
                                    Livrer
                                </Button>
                                : <></>}

                            {openDateDialog &&
                                <Intern_delivery_supposed_date_modal
                                    open_deliveryDate_modal={openDateDialog}
                                    setOpen_deliveryDate_modal={setOpenDateDialog}
                                    request_code={request_code} setWait_submitting={setWait_submitting}
                                    setStockStatus={setStockStatus} />}



                        </div>

                    </div>

                    {/* Render the dialog dyal product replacement */}
                    {selectedMismatchProduct && (
                        <ProductReplacement
                            requested_products={requested_products}
                            selectedProduct={selectedMismatchProduct}
                            onConfirm={handleConfirmReplacement}
                            onCancel={() => setSelectedMismatchProduct(null)}
                        />
                    )}

                    {
                        open_reason_modal !== null
                            ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                            : <></>
                    }

                </Accordion.Body>
            </Accordion.Item>
            <SearchStock open={openSearchDialog} onClose={handleCloseSearch} categories={categories} existing_products={existing_products}
                suppliers={suppliers} get_supplier_by_id={get_supplier_by_id}
                onChooseFromStock={handleChooseFromStock}></SearchStock>
        </Accordion>
    );

}


export default Stock_details_accordian;
